var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useEffect, useState } from 'react';
import FadeIn from '../../../components/Animation/FadeIn';
import Paragraph from '../../../components/Typography/Paragraph';
import FormRow from '../../../components/Form/Row';
import TextInput from '../../../components/Fields/TextInput';
import { Fields } from '../../../utils/Fields';
import { useValidation } from '../../../hooks/useValidation';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import Select from '../../../components/Fields/Select';
import TrueFalseInput from '../../../components/Fields/TrueFalseInput';
import axiosInstance from '../../../config/axios';
import { api } from '../../../config/api';
import { Plus, Trash } from 'react-feather';
import Button from '../../../components/Button';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { serialize } from 'object-to-formdata';
import Location from '../../../components/Fields/Location';
import { toast } from 'react-toastify';
import { deepEqual, pick } from '../../../utils/Objects';
import { useUser } from '../../../hooks/useUser';
import JobsInput from '../../../components/Fields/JobsInput';
import { RoutePaths } from '../../../config/routes';
import { useSignOut } from 'react-auth-kit';
import { usePlaceholder } from '../../../hooks/usePlaceholder';
var DashboardProfile = function () {
    var fields = [
        'last_name',
        'first_name',
        'artist_name',
        'gender',
        'display_gender',
        'pronoun',
        'display_pronoun',
        'professional_status',
        'display_professional_status',
        'jobs',
        'location',
        'second_location',
        'custom_jobs',
        'sorted_jobs',
    ];
    var _a = useState(false), loading = _a[0], setLoading = _a[1];
    var _b = useState([]), categories = _b[0], setCategories = _b[1];
    var _c = useState([]), status = _c[0], setStatus = _c[1];
    var _d = useState({
        genders: [],
        pronouns: [],
    }), identities = _d[0], setIdentities = _d[1];
    var _e = useState(false), secondLocation = _e[0], setSecondLocation = _e[1];
    var _f = useState(true), isProfessional = _f[0], setIsProfessional = _f[1];
    var navigate = useNavigate();
    var signOut = useSignOut();
    var _g = useOutletContext(), user = _g.user, handleUser = _g.handleUser, handleFormError = _g.handleFormError;
    var removeUserStorage = useUser().removeUserStorage;
    var placeholders = usePlaceholder();
    var _h = useValidation(), textOptional = _h.textOptional, textRequired = _h.textRequired, booleanNullable = _h.booleanNullable, arrayNullable = _h.arrayNullable, locationRequired = _h.locationRequired, locationOptional = _h.locationOptional;
    var schema = yup.object().shape({
        last_name: textRequired,
        first_name: textRequired,
        artist_name: textOptional,
        gender: textOptional,
        display_gender: booleanNullable,
        pronoun: textOptional,
        display_pronoun: booleanNullable,
        professional_status: textRequired,
        display_professional_status: booleanNullable,
        jobs: arrayNullable,
        location: locationRequired,
        second_location: locationOptional,
        custom_jobs: arrayNullable,
        sorted_jobs: arrayNullable,
    });
    var _j = useForm({
        resolver: yupResolver(schema),
        defaultValues: __assign(__assign({}, pick(user, fields)), { display_gender: false }),
    }), handleSubmit = _j.handleSubmit, control = _j.control, getValues = _j.getValues, reset = _j.reset, setValue = _j.setValue, watch = _j.watch;
    useEffect(function () {
        axiosInstance.get(api.jobs.categories).then(function (_a) {
            var data = _a.data;
            setCategories(data);
            axiosInstance.get(api.identities.all).then(function (_a) {
                var data = _a.data;
                setIdentities(data);
                axiosInstance.get(api.professionalStatus.all).then(function (_a) {
                    var data = _a.data;
                    setStatus(data);
                });
            });
        });
        setIsProfessional((user === null || user === void 0 ? void 0 : user.category.slug) === 'professional');
        setSecondLocation(!!(user === null || user === void 0 ? void 0 : user.second_location));
    }, []);
    var onSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var formData, response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if ((user === null || user === void 0 ? void 0 : user.second_location) && !secondLocation) {
                        reset(__assign(__assign({}, data), { second_location: null }));
                    }
                    if (deepEqual(getValues(), pick(user, fields)))
                        return [2 /*return*/];
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    formData = serialize(getValues(), { indices: true, allowEmptyArrays: true });
                    return [4 /*yield*/, axiosInstance.post(api.user.update, formData)];
                case 2:
                    response = _a.sent();
                    handleUser(response.data);
                    reset(pick(response.data, fields));
                    toast.success('Vos informations ont bien été mises à jour');
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    handleFormError(error_1);
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleLogout = function () {
        removeUserStorage();
        signOut();
        navigate(RoutePaths.SIGN_IN, { replace: true });
    };
    return (<FadeIn>
      <div className="my-10 grid gap-6 lg:my-20 lg:grid-cols-12">
        <div className="lg:col-span-10 lg:col-start-2 xl:col-span-8 xl:col-start-3">
          {isProfessional && (<Paragraph className="mb-8 font-medium">
              Ces informations en haut de profil permettent de mieux comprendre qui vous êtes.
            </Paragraph>)}
          <form onSubmit={handleSubmit(onSubmit)}>
            {!isProfessional && (<div className="flex flex-col gap-6">
                <FormRow>
                  <TextInput label="Nom" type={Fields.TEXT} name="last_name" placeholder={placeholders.lastName} control={control} required disabled/>
                  <TextInput label="Prénom" type={Fields.TEXT} name="first_name" placeholder={placeholders.firstName} control={control} required disabled/>
                </FormRow>
              </div>)}
            {isProfessional && (<div className="flex flex-col gap-6">
                <FormRow>
                  <TextInput label="Nom" type={Fields.TEXT} name="last_name" placeholder={placeholders.lastName} control={control} required/>
                  <TextInput label="Prénom" type={Fields.TEXT} name="first_name" placeholder={placeholders.firstName} control={control} required/>
                </FormRow>
                <FormRow>
                  <TextInput label="Nom d’artiste/Surnom" type={Fields.TEXT} name="artist_name" placeholder={placeholders.artistName} control={control} subInstructions="Indiquez le pseudonyme sous lequel on vous connaît le mieux."/>
                </FormRow>

                <FormRow>
                  <Select label="Genre" name="gender" control={control} subInstructions="Cette information permet aux équipes Majeur·e·s de vérifier la conformité des profils référencés." choices={identities.genders}/>
                </FormRow>
                {/* <FormRow>
              <TrueFalseInput
                label="Afficher sur mon profil"
                name="display_gender"
                control={control}
              />
            </FormRow>*/}

                <FormRow>
                  <Select label="Pronom" name="pronoun" control={control} subInstructions="Cette précision permet aux personnes qui souhaitent vous contacter de le faire de la bonne manière." choices={identities.pronouns}/>
                </FormRow>
                <FormRow>
                  <TrueFalseInput label="Afficher sur mon profil" name="display_pronoun" control={control}/>
                </FormRow>
                <FormRow>
                  <Select label="Statut professionnel" name="professional_status" control={control} required subInstructions="Multi-casquettes ? Choisissez le statut sous lequel vous souhaitez être référencé·e." choices={status}/>
                </FormRow>
                <FormRow>
                  <TrueFalseInput label="Afficher sur mon profil" name="display_professional_status" control={control}/>
                </FormRow>
                <FormRow>
                  <JobsInput name="jobs" control={control} categories={categories} custom={watch('custom_jobs')} handleCustom={function (value) {
                return setValue('custom_jobs', value);
            }} sorted={watch('sorted_jobs')} handleSorted={function (value) {
                return setValue('sorted_jobs', value);
            }}/>
                </FormRow>
                <FormRow>
                  <Location label="Localisation" name="location" placeholder={placeholders.location} control={control} required/>
                </FormRow>

                {!secondLocation && (<Button type="inline" icon={Plus} side="start" className="-mt-3 self-start text-brand-02" onClick={function () { return setSecondLocation(true); }}>
                    Ajouter un lieu
                  </Button>)}

                {secondLocation && (<FormRow className="-mt-3 !flex-row items-end">
                    <Location label="Autre localisation" name="second_location" placeholder={placeholders.location} control={control}/>
                    <Trash size={24} className="mb-4 cursor-pointer text-gray-500 transition-colors lg:hover:text-black" onClick={function () { return setSecondLocation(false); }}/>
                  </FormRow>)}
                <Button submit loading={loading} className="sm:self-end">
                  Mettre à jour mes informations
                </Button>
              </div>)}
          </form>
          <div className="mt-6 flex w-full justify-end">
            <Button alert="danger" type="outlined" onClick={handleLogout}>
              Me déconnecter
            </Button>
          </div>
        </div>
      </div>
    </FadeIn>);
};
export default DashboardProfile;
